import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { HintManagementModel } from '@data-layer/models/management/common';

@Injectable({
  providedIn: 'root',
})
export class HintsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: PaginationSearchModel, isShowLoader: boolean = true): Observable<PaginatedResultModel<HintManagementModel>> {
    return this.apiService.get<PaginatedResultModel<HintManagementModel>>(
      `${environment.url.prefixCustoms}v2/management/hints`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public get(hintId: number): Observable<HintManagementModel> {
    return this.apiService.get<HintManagementModel>(`${environment.url.prefixCustoms}v2/management/hints/${hintId}`);
  }

  public create(hint: HintManagementModel): Observable<HintManagementModel> {
    return this.apiService.post<HintManagementModel>(`${environment.url.prefixCustoms}v2/management/hints`, hint);
  }

  public update(hint: HintManagementModel): Observable<HintManagementModel> {
    return this.apiService.put<HintManagementModel>(`${environment.url.prefixCustoms}v2/management/hints/${hint.id}`, hint);
  }

  public delete(hintId: number): Observable<void> {
    return this.apiService.delete<void>(`${environment.url.prefixCustoms}v2/management/hints/${hintId}`);
  }
}
